import React, { Component } from "react";

export default class InternalBanner extends Component {
  render() {
    const { banner } = this.props;
    return (
      <div className="header-banner">
        <img className="img-fluid" src={banner} alt="" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/internal-banner.js